export const isBrowser = typeof window !== 'undefined'

export const isDev = process.env.NODE_ENV === 'development'

export const isStaging = !!process.env.STAGING
